package scenes.test

import com.soywiz.klock.*
import com.soywiz.korev.*
import com.soywiz.korge.baseview.*
import com.soywiz.korge.component.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.view.*
import com.soywiz.korio.async.*
import scenes.test.*

class GamePauseScene: Scene() {
    override suspend fun SContainer.sceneInit() {
        text("Pause", 32.0) {
            smoothing = false
            position(10, 10)
        }

        this.addComponent(object: KeyComponent {
            private val lastState: Array<KeyEvent.Type?> = Array(Key.values().size) { null }

            override val view: BaseView = sceneContainer

            override fun Views.onKeyEvent(event: KeyEvent) {

                when (event.key) {
                    Key.ESCAPE -> {
                        if(event.typeDown && lastState[Key.ESCAPE.ordinal] != KeyEvent.Type.DOWN) {
                            lastState[Key.ESCAPE.ordinal] = KeyEvent.Type.DOWN
                            launch {
                                sceneContainer.changeTo<Box2dScene>(time = 0.5.seconds)
                            }
                        }
                    }
                    else -> {}
                }
            }

        })
    }
}
